import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableRow, Table,
} from '@material-ui/core';

const cellCommonStyle = { border: '1px solid #e0e0e0', padding: '2px', paddingLeft: '5px', paddingRight: '5px' };
const cell10 = { ...cellCommonStyle, width: '10%' }
const cell20 = { ...cellCommonStyle, width: '20%' };
const cell50 = { ...cellCommonStyle, width: '50%' };
const cell80 = { ...cellCommonStyle, width: '80%' };
const cell100 = { ...cellCommonStyle, width: '100%' };

const costOfSaleLabels = ['Green Leaf Expenses', 'Bl Arrearas', 'Leaf Transportation - Estate Vehicles', 'Prime Cost'];
const costOfSaleIDs = ['2', '3', '4', '5'];
const costOfSaleKeys = ['GreenLeafExpenses', 'Blarrearas', 'LeafTransportation', 'PrimeCost'];

const factoryOverheadLables = ['Factory Staff Salary', 'Factory Labour Payment', 'Bonus', 'Tea & Meals Expenses', 'Transport of Workers', 'Power', 'Fuel Firewood', 'Maintenance & Upkeep', 'Paper Bag', 'Sundry Expenses', 'Genarator Maintenance', 'JMC, Tata, Bolero', 'Total Factory Overhead', 'Total Cost of Manufacture'];
const factoryOverheadIDs = ['6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'];
const factoryOverheadKeys = ['FactoryStaffSalary', 'FactoryLabourPayment', 'Bonus', 'TeaAndMealsExpenses', 'TransportOfWorkers', 'Power', 'FuelFirewood', 'MaintenanceAndUpkeep', 'PaperBag', 'SundryExpenses', 'GeneratorMaintenance', 'JMC_Tata_Bolero', 'TotalFactoryOverhead', 'TotalCostofManufacture'];

const expensesLabels = ['Office Staff Salary', 'Factory License', 'Upkeep of Bungalow & Quarters', 'Charity & Donation', 'Water Supply', 'Welfare & Sports', 'Travelling', 'Communication', 'Postage, Printing & Stationaries', 'Office Upkeep', 'Other Expenses', 'Total Expenses'];
const expensesIDs = ['20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
const expensesKeys = ['OfficeStaffSalary', 'FactoryLicense', 'UpkeepofBungalow_Quarters', 'Charity_Donation', 'WaterSupply', 'Welfare_Sports', 'Travelling', 'Communication', 'Postage_Printing_Stationaries', 'OfficeUpkeep', 'OtherExpenses', 'TotalExpenses'];

const teaSaleExpensesLabels = ['Tea Sale Expenses', 'Made Tea Transportation', 'Total Tea Sale Expenses'];
const teaSaleExpensesIDs = ['32', '33', '34'];
const teaSaleExpensesKeys = ['TeaSaleExpenses', 'MadeTeaTransportation', 'TotalTeaSaleExpenses'];

const financialOtherExpensesLabels = ['Bank Charges', 'OD Interest', 'Broker Advance Interest', 'Bank Loan Interest', 'Total Financial Expenses'];
const financialOtherExpensesIDs = ['35', '36', '37', '38', '39'];
const financialOtherExpensesKeys = ['BankCharges', 'ODInterest', 'BrokerAdvanceInterest', 'BankLoanInterest', 'TotalFinancialExpenses'];

const finalStatsLabels = ['Total Expenses', 'Net Sale Average', 'Variance'];
const finalStatsIDs = ['40', '', ''];
const finalStatsKeys = ['TotalExpenses', 'NetSaleAverage', 'Variance'];

export default class ComponentToPrint extends React.Component {

  render() {
    const selectedSearchValues = this.props.selectedSearchValues;
    const reportData = this.props.reportData;
    const copValues = this.props.copValues;
    const GroupList = this.props.GroupList;
    const FactoryList = this.props.FactoryList;

    return (
      <div>
        <div>&nbsp;</div>
        <div className="row pl-2 pb-4 pt-4">
          <h3><center> {GroupList[selectedSearchValues.groupID]}&nbsp; {FactoryList[selectedSearchValues.factoryID]} </center></h3>
          <h3><center>  COP REPORT OF {selectedSearchValues.applicableMonthName}, {selectedSearchValues.applicableYear}</center></h3>
          <div>&nbsp;</div>
        </div>
        <div>

          <Box minWidth={650}>
            <TableContainer style={{ border: '1px solid #e0e0e0', borderRadius: 4 }}>
              <Table size="small" aria-label="simple table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={2} rowSpan={2} align="center" style={cell50}><u>EXPENSES</u></TableCell>
                    <TableCell colSpan={2} align="center" style={cell20}>{selectedSearchValues.applicableMonthName} - {selectedSearchValues.applicableYear}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="center" style={cell20}>Expenses</TableCell>
                    <TableCell align="center" style={cell20}>COP</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" style={cell50}>Made Tea</TableCell>
                    <TableCell align="center" style={cell10}></TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                    <TableCell align="right" style={cell20}>
                      {Number(selectedSearchValues.teaQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Cost of Sales</u></TableCell>
                  </TableRow>
                  {costOfSaleKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell50}>
                        {costOfSaleLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="center" style={cell10}>
                        {costOfSaleIDs[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Add factory overhead</u></TableCell>
                  </TableRow>
                  {factoryOverheadKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell50}>
                        {factoryOverheadLables[rowIndex]}
                      </TableCell>
                      <TableCell align="center" style={cell10}>
                        {factoryOverheadIDs[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Less - Expenses</u></TableCell>
                  </TableRow>
                  {expensesKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell50}>
                        {expensesLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="center" style={cell10}>
                        {expensesIDs[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Less - Tea Sales Expenses</u></TableCell>
                  </TableRow>
                  {teaSaleExpensesKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell50}>
                        {teaSaleExpensesLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="center" style={cell10}>
                        {teaSaleExpensesIDs[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Less - Financial & Other Expenses</u></TableCell>
                  </TableRow>
                  {financialOtherExpensesKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell50}>
                        {financialOtherExpensesLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="center" style={cell10}>
                        {financialOtherExpensesIDs[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}

                  <TableRow >
                    <TableCell align="left" style={{ ...cell50, height: '2rem' }}></TableCell>
                    <TableCell align="center" style={{ ...cell10, height: '2rem' }}></TableCell>
                    <TableCell align="right" style={{ ...cell20, height: '2rem' }}></TableCell>
                    <TableCell align="right" style={{ ...cell20, height: '2rem' }}></TableCell>
                  </TableRow>
                  {finalStatsKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell50}>
                        {finalStatsLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="center" style={cell10}>
                        {finalStatsIDs[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}

                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}